export enum XmStatus {    
    XmCancelled = 0,
    XmRequested = 1,
    ShippedOut = 2,
    Received = 3,
    ShippedRemote = 4,
    ShippedBack = 5,
    ReceivedBack = 6,
    ResultsRecorded = 7,
    PendingNkrLab = 8,
    FinalXmMissing = 99
}